export default "__VITE_ASSET__C7_V7J0x__"